import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
	Button,
	DatePicker,
	Dropdown,
	Form,
	Image,
	Input,
	Menu,
	Radio,
	Space,
	Spin,
	TimePicker,
} from "antd";
import AWS from "aws-sdk";
import moment from "moment";

import colorSyntax from "@toast-ui/editor-plugin-color-syntax";
import { Editor } from "@toast-ui/react-editor";
import Swal from "sweetalert2";

import partnersApi from "../../../apis/Partners.api";
import { setLoading } from "../../../redux/store/common/commonDuck";
import { toastAlert } from "../../AlertComponent";

AWS.config.update({
	accessKeyId: process.env.REACT_APP_S3_ACCESSKEYID,
	secretAccessKey: process.env.REACT_APP_S3_SECRETACCESSKEY,
	region: process.env.REACT_APP_S3_REGION,
});

const s3 = new AWS.S3();

const EditCommunityWriteComponent = ({
	setCommunityWriteShow,
	selectCommunity,
}) => {
	const dispatch = useDispatch();
	const isLoading = useSelector((state) => state.common.loading);
	const setIsLoading = (value) => dispatch(setLoading(value));

	const user = useSelector((state) => state.auth.user);
	const [imgUploadLoading, setImgUploadLoading] = useState(false);
	const [categoryList, setCategoryList] = useState([]);
	const [category, setCategory] = useState("카테고리");
	const [content, setContent] = useState({
		category_id: null,
		title: null,
		body: null,
	});
	const [openValue, setOpenValue] = useState(1);
	const [openValueDate, setOpenValueDate] = useState(
		moment().add("5", "minutes")
	);

	const inputRef = useRef(null);

	const [biggestTitle, setBiggestTitle] = useState(0);

	const contentReg = new RegExp(
		"font[ㄱ-ㅎ|ㅏ-ㅣ|가-힣0-9A-Za-z,.!;:\\)+\\-$&\\( ]*;",
		"g"
	);

	useEffect(() => {
		getCommunityCategoryDropdownList();

		setContent({
			...content,
			category_id: selectCommunity?.category_id ?? null,
			title: selectCommunity?.title ?? null,
			body: selectCommunity?.body ?? null,
		});
		setOpenValue(selectCommunity?.post_from ? 2 : 1);
		if (selectCommunity?.post_from) {
			setOpenValueDate(moment(selectCommunity?.post_from));
		} else {
			// setOpenValueDate(moment().endOf("day"))
			setOpenValueDate(moment().add(5, "minutes"));
		}

		let communityImageList = selectCommunity?.communityImageList;
		if (communityImageList?.length > 0) {
			// 타이틀 중 가장 큰 값 저장
			let bigTitle =
				communityImageList
					?.reduce((prev, value) => {
						return prev?.title?.split("-")?.[1] >= value?.title?.split("-")?.[1]
							? prev
							: value;
					})
					?.title?.split("-")?.[1] ?? 0;
			setBiggestTitle(bigTitle ? Number(bigTitle) : 0);

			let list = [];
			let photos = [];
			for (let i = 0; i < communityImageList?.length; i++) {
				let source = `${process.env.REACT_APP_S3_HOST}/image/together/community/${selectCommunity?.influencer_id}/${communityImageList[i]?.title}.${communityImageList[i]?.img_type}`;
				list.push(source);
				photos.push({
					title: communityImageList[i]?.title,
					source: source,
					type: `image/${communityImageList[i]?.img_type}`,
				});
			}
			// 최대 5개까지
			setImageList(list.slice(0, 5));
			setPhotoList(photos.slice(0, 5));
		}
	}, [selectCommunity]);

	/**
	 * 카테고리 이름 정하기
	 */
	useEffect(() => {
		if (selectCommunity?.category_id && !!categoryList?.length) {
			const name = categoryList.filter(
				(item) => item.id === selectCommunity.category_id
			)[0];
			setCategory(name?.category_name);
		}
	}, [selectCommunity, categoryList]);

	/**
	 * 카테고리 드롭다운 리스트 가져오기
	 * @returns {Promise<void>}
	 */
	const getCommunityCategoryDropdownList = async () => {
		setIsLoading(true);
		const param = {
			influencerId:
				user?.role === "level_1" || user?.role === "super_admin"
					? user?.id
					: user?.partners_id,
		};
		const res = await partnersApi.getCommunityCategoryList(param);
		if (res.code === 200) {
			setCategoryList(res.result);
		} else {
			Swal.fire({
				customClass: "alert-custom",
				text: "오류가 발생했습니다. 잠시 후 다시 시도해주세요.",
				confirmButtonText: "확인",
			});
		}
		setIsLoading(false);
	};

	const dropdownCategory = (
		<Menu>
			{categoryList?.map((item, idx) => (
				<Menu.Item
					key={`category-${item?.id}-${idx}`}
					onClick={() => {
						setCategory(item.category_name);
						setContent({ ...content, category_id: item?.id });
					}}
				>
					{item.category_name}
				</Menu.Item>
			))}
		</Menu>
	);

	const handleCommunityContent = (e) => {
		let { name, value } = e.target;
		setContent({
			...content,
			[name]: value,
		});
	};

	/**
	 * 에디터 내 이미지 업로드 처리
	 * @param blob
	 * @param callback
	 * @returns {Promise<*>}
	 */
	const addImageBlobHook = async (blob, callback) => {
		console.log("addImageBlobHook :: event 실행");
		setImgUploadLoading(true);
		const userId =
			user?.role === "level_1" || user?.role === "super_admin"
				? user?.id
				: user?.partners_id;
		const fileType = blob?.type?.split("/")[1];
		const regex = new RegExp(`.${fileType}$`, "g");
		const s3Path = `image/together/community/${userId}/inContent/${blob.name.replace(
			regex,
			""
		)}_${Math.random().toString().slice(2, 6)}_${moment().format(
			"YYYYMMDDHHmmss"
		)}.${fileType}`;
		let s3Param = {
			Bucket: process.env.REACT_APP_S3_BUCKETNAME,
			Key: s3Path,
			Body: blob,
		};
		console.log("param = ", s3Param);
		let res = await s3.putObject(s3Param).promise();

		if (res.$response.httpResponse.statusCode === 200) {
			console.log("s3-upload-success", res);
			const url = `${process.env.REACT_APP_S3_HOST}/${s3Path}`;
			setImgUploadLoading(false);
			return callback(url);
		} else {
			setImgUploadLoading(false);
			Swal.fire({
				customClass: "alert-custom",
				text: "이미지 업로드시 오류가 발생했습니다.\n다시 시도하시거나 계속해서 오류가 발생한다면 관리자에게 문의해주시길 부탁드립니다.",
				confirmButtonText: "확인",
			}).then(() => {
				console.log("s3-upload-error");
				return callback(null);
			});
		}
	};

	const [imageList, setImageList] = useState([]);
	const [photoList, setPhotoList] = useState([]);

	/**
	 * 프론트 내 업로드 버튼 클릭
	 */
	const onUploadImageClick = () => {
		if (imageList?.length >= 5) {
			toastAlert("이미지는 최대 5장까지 가능합니다.");
		} else {
			if (!inputRef.current) {
				return;
			}
			inputRef.current.click();
		}
	};

	/**
	 * 프론트 내 업로드 진행
	 * @param e
	 */
	const onUploadImage = (e) => {
		if (!e.target.files) {
			return;
		}
		const fileList = e.target.files;
		const urlList = [...imageList];
		const photoInfoList = [...photoList];
		for (let i = 0; i < fileList?.length; i++) {
			const fileUrl = URL?.createObjectURL(fileList[i]);
			urlList.push(fileUrl);
			photoInfoList.push({
				file: fileList[i],
				source: fileUrl,
				type: fileList[i]?.type,
			});
		}
		setImageList(urlList?.slice(0, 5));
		setPhotoList(photoInfoList?.slice(0, 5));
	};

	/**
	 * 목록으로
	 */
	const goBackToCommunityList = () => {
		if (
			!!content.category_id?.length ||
			!!content.title?.length ||
			!!content.body?.length ||
			!!imageList?.length
		) {
			Swal.fire({
				customClass: "alert-custom",
				text: `작성하던 글이 있습니다. 취소하시겠습니까?`,
				showCancelButton: true,
				confirmButtonText: "확인",
				cancelButtonText: "취소",
			}).then(async (result) => {
				if (result.isConfirmed) {
					setCommunityWriteShow(false);
					setContent({
						category_id: null,
						title: null,
						body: null,
					});
					setImageList([]);
					setPhotoList([]);
				}
			});
		} else {
			setCommunityWriteShow(false);
			setContent({
				category_id: null,
				title: null,
				body: null,
			});
			setImageList([]);
			setPhotoList([]);
		}
	};

	/**
	 * 작성완료
	 */
	const submitCommunityContent = async () => {
		let type = selectCommunity?.id ? "edit" : "save";

		let editorContent = editorRef.current?.getInstance().getHTML();

		if (
			content.category_id === null ||
			!content?.title?.trim()?.length ||
			(!content?.body?.trim()?.length && !editorContent?.length)
		) {
			toastAlert("카테고리, 제목, 내용을 모두 선택/입력해주세요.");
		} else {
			if (openValue !== 1) {
				const time = await partnersApi.getServerTime();
				if (time.code === 200) {
					let serverTime = moment(time.result);
					if (moment.duration(openValueDate.diff(serverTime)).asMinutes() < 5) {
						Swal.fire({
							customClass: "alert-custom",
							text: "예약글은 현시간 기준 5분 이후로 부터 가능합니다.",
							confirmButtonText: "확인",
						}).then(() => setOpenValueDate(moment().add(5, "minutes")));
					} else {
						Swal.fire({
							customClass: "alert-custom",
							text: `작성을 완료하고 적용하시겠습니까?`,
							showCancelButton: true,
							confirmButtonText: "확인",
							cancelButtonText: "취소",
						}).then(async (result) => {
							if (result.isConfirmed) {
								setIsLoading(true);
								let param = {
									influencer_id:
										user?.role === "level_1" || user?.role === "super_admin"
											? user?.id
											: user?.partners_id,
									category_id: content?.category_id,
									title: content?.title,
									body:
										editorContent
											?.replaceAll(`<img class="ProseMirror-separator">`, "")
											?.replaceAll(
												`contenteditable="false">`,
												`contenteditable="false" style="width: 100%;">`
											) ??
										content?.body
											?.replaceAll(`<img class="ProseMirror-separator">`, "")
											?.replaceAll(
												`contenteditable="false">`,
												`contenteditable="false" style="width: 100%;">`
											),
									created_by: user?.id,
									updated_by: user?.id,
									post_from: openValue === 2 ? openValueDate : null,
								};
								if (type === "edit") {
									param = {
										...param,
										id: selectCommunity?.id,
									};
								}

								if (type === "edit") {
									const res = await partnersApi.updateCommunityContent(param);
									if (res.code === 200) {
										addCommunityImageList(param);
									} else {
										Swal.fire({
											customClass: "alert-custom",
											text: "오류가 발생했습니다. 잠시 후 다시 시도해주세요.",
											confirmButtonText: "확인",
										}).then(() => {
											console.log("edit-error");
											setIsLoading(false);
										});
									}
								} else {
									const res = await partnersApi.createCommunityContent(param);
									if (res.code === 200) {
										addCommunityImageList(res.result);
									} else {
										Swal.fire({
											customClass: "alert-custom",
											text: "오류가 발생했습니다. 잠시 후 다시 시도해주세요.",
											confirmButtonText: "확인",
										}).then(() => {
											console.log("save-error");
											setIsLoading(false);
										});
									}
								}
							}
						});
					}
				}
			} else {
				Swal.fire({
					customClass: "alert-custom",
					text: `작성을 완료하고 적용하시겠습니까?`,
					showCancelButton: true,
					confirmButtonText: "확인",
					cancelButtonText: "취소",
				}).then(async (result) => {
					if (result.isConfirmed) {
						setIsLoading(true);
						let param = {
							influencer_id:
								user?.role === "level_1" || user?.role === "super_admin"
									? user?.id
									: user?.partners_id,
							category_id: content?.category_id,
							title: content?.title,
							body:
								editorContent
									?.replaceAll(`<img class="ProseMirror-separator">`, "")
									?.replaceAll(
										`contenteditable="false">`,
										`contenteditable="false" style="width: 100%;">`
									) ??
								content?.body
									?.replaceAll(`<img class="ProseMirror-separator">`, "")
									?.replaceAll(
										`contenteditable="false">`,
										`contenteditable="false" style="width: 100%;">`
									),
							created_by: user?.id,
							updated_by: user?.id,
							post_from: openValue === 2 ? openValueDate : null,
						};
						if (type === "edit") {
							param = {
								...param,
								id: selectCommunity?.id,
							};
						}

						if (type === "edit") {
							const res = await partnersApi.updateCommunityContent(param);
							if (res.code === 200) {
								addCommunityImageList(param);
							} else {
								Swal.fire({
									customClass: "alert-custom",
									text: "오류가 발생했습니다. 잠시 후 다시 시도해주세요.",
									confirmButtonText: "확인",
								}).then(() => {
									console.log("edit-error");
									setIsLoading(false);
								});
							}
						} else {
							const res = await partnersApi.createCommunityContent(param);
							if (res.code === 200) {
								addCommunityImageList(res.result);
							} else {
								Swal.fire({
									customClass: "alert-custom",
									text: "오류가 발생했습니다. 잠시 후 다시 시도해주세요.",
									confirmButtonText: "확인",
								}).then(() => {
									console.log("save-error");
									setIsLoading(false);
								});
							}
						}
					}
				});
			}
		}
	};

	/**
	 * 이미지 업로드
	 * @returns {Promise<void>}
	 * result: 결과값 -> id
	 * type: edit / save
	 */
	const addCommunityImageList = async (result) => {
		let list = [];
		for (let i = 0; i < photoList?.length; i++) {
			let photo = photoList[i];

			if (photo?.file) {
				uploadToS3(result, photo, i);
				let fileType = photo?.type?.split("/")[1];
				list.push({
					title: `${result?.id}-${biggestTitle + i + 1}`,
					img_type: fileType,
				});
			} else {
				let fileType = photo?.type?.split("/")[1];
				list.push({
					title: photo?.title ?? `${result?.id}-${biggestTitle + i + 1}`,
					img_type: fileType,
				});
			}
		}

		const param = {
			id: result?.id,
			influencer_id:
				user?.role === "level_1" || user?.role === "super_admin"
					? user?.id
					: user?.partners_id,
			// created_by: (user?.role === "level_1" || user?.role === "super_admin") ? user?.id : user?.partners_id,
			created_by: user?.id,
			communityImageList: [...list],
		};
		const res = await partnersApi.createCommunityImages(param);
		if (res.code === 200) {
			Swal.fire({
				customClass: "alert-custom",
				text: "성공적으로 적용되었습니다!",
				confirmButtonText: "확인",
			}).then(() => {
				setCommunityWriteShow(false);
				setIsLoading(false);
			});
		} else {
			Swal.fire({
				customClass: "alert-custom",
				text: "오류가 발생했습니다. 잠시 후에 다시 시도해주세요.",
				confirmButtonText: "확인",
			}).then(() => {
				console.log("image-list-error");
				setIsLoading(false);
			});
		}
	};

	/**
	 * 이미지 S3 업로드
	 * @param reviewId
	 */
	const uploadToS3 = async (result, photo, i) => {
		let fileType = photo?.type?.split("/")[1];
		const userId =
			user?.role === "level_1" || user?.role === "super_admin"
				? user?.id
				: user?.partners_id;
		let s3Path = `image/together/community/${userId}/${result?.id}-${
			biggestTitle + i + 1
		}.${fileType}`;
		//aws-sdk 사용
		let params = {
			Bucket: process.env.REACT_APP_S3_BUCKETNAME,
			Key: s3Path,
			Body: photo.file,
		};

		let res = await s3.putObject(params).promise();

		if (res.$response.httpResponse.statusCode === 200) {
			console.log("s3-upload-success");
		} else {
			Swal.fire({
				customClass: "alert-custom",
				text: "이미지 업로드 오류",
				confirmButtonText: "확인",
			}).then(() => {
				console.log("s3-upload-error");
				setIsLoading(false);
			});
		}
	};

	/**
	 * 이미지 삭제 (목록에서 제거 -> 작성/수정완료 클릭 시 적용)
	 * @param idx
	 */
	const onDeleteImage = (idx) => {
		Swal.fire({
			customClass: "alert-custom",
			text: `해당 이미지를 삭제하시겠습니까?`,
			showCancelButton: true,
			confirmButtonText: "확인",
			cancelButtonText: "취소",
		}).then(async (result) => {
			if (result.isConfirmed) {
				let list = [...imageList];
				let photos = [...photoList];
				list.splice(idx, 1);
				photos.splice(idx, 1);
				setImageList(list);
				setPhotoList(photos);
			}
		});
	};

	/**
	 * 예약글 현시간 5분 이후로 작성 가능
	 * @param value
	 * @returns {Promise<void>}
	 */
	const handleDateTimeValue = async (value) => {
		if (openValue === 2) {
			const res = await partnersApi.getServerTime();
			if (res.code === 200) {
				let serverTime = moment(res.result);
				if (moment.duration(value.diff(serverTime)).asMinutes() < 5) {
					Swal.fire({
						customClass: "alert-custom",
						text: "예약글은 현시간 기준 5분 이후로 부터 가능합니다.",
						confirmButtonText: "확인",
					}).then(() => setOpenValueDate(moment(value).add(5, "minutes")));
				} else {
					setOpenValueDate(value);
				}
			}
		}
	};
	const editorRef = useRef(null);

	useEffect(() => {
		if (!!selectCommunity && !!selectCommunity?.id && !!editorRef.current) {
			if (selectCommunity?.body?.includes("<p")) {
				editorRef.current?.getInstance().setHTML(selectCommunity?.body);
			}
		}
	}, [selectCommunity, editorRef.current]);

	const toolbarItems = [
		["bold", "italic", "strike"],
		["link"],
		// ['table', 'link'],
		// ['hr'],
		// ["table"],
		// ["ul", "ol"],
		// ['task', 'code'],
		["scrollSync"],
	];
	const editorHeight = "65vh";

	return (
		<div className={`edit-community-write-div`}>
			<div className={`edit-community-write-header`}>
				<Dropdown
					overlay={dropdownCategory}
					trigger={["click"]}
					disabled={isLoading}
				>
					<Button
						style={{ display: "flex", alignItems: "center", gap: "3px" }}
						disabled={isLoading}
					>
						{category ?? "카테고리"}
						<img
							src={`/assets/images/report/report-search-date-icon-down.png`}
							alt={`드롭다운`}
							style={{
								height: "auto",
								width: "0.8em",
							}}
						/>
					</Button>
				</Dropdown>
				<Input
					type={`text`}
					placeholder={`제목을 입력해주세요`}
					name={"title"}
					value={content.title}
					onChange={handleCommunityContent}
					disabled={isLoading}
				/>
			</div>

			<div
				style={{
					position: "relative",
				}}
			>
				<Editor
					ref={editorRef}
					initialEditType={"wysiwyg"} // wysiwyg & markdown
					initialValue={""} // 글 수정 시 사용
					previewStyle={window?.innerWidth > 1000 ? "vertical" : "tab"} // tab, vertical
					hideModeSwitch={true}
					theme={""} // '' & 'dark'
					usageStatistics={false}
					toolbarItems={toolbarItems}
					useCommandShortcut={true}
					plugins={[colorSyntax]}
					language="ko-KR"
					hooks={{
						addImageBlobHook: addImageBlobHook,
					}}
					height={editorHeight}
					disabled={imgUploadLoading}
					onChange={() => {
						let contentText = editorRef.current?.getInstance().getHTML();
						console.log("onChange :: text = ", contentText);
						if (contentReg.test(contentText)) {
							editorRef.current
								?.getInstance()
								.setHTML(contentText.replaceAll(contentReg, ""));
						}
					}}
				/>

				{/*내용 중간에 첨부되는 이미지 업로드 로딩*/}
				{imgUploadLoading && (
					<div
						style={{
							position: "absolute",
							top: 0,
							bottom: 0,
							left: 0,
							right: 0,
							backgroundColor: "rgba(0,0,0,0.1)",
							zIndex: 20,
						}}
					>
						<div
							style={{
								position: "absolute",
								top: "50%",
								left: 0,
								right: 0,
							}}
						>
							<Spin
								style={{
									width: "100%",
								}}
							/>
							<p
								style={{
									textAlign: "center",
								}}
							>
								이미지를 업로드하고 있습니다.
							</p>
						</div>
					</div>
				)}
			</div>
			{/*<Input.TextArea*/}
			{/*	className={`edit-community-write-textarea`}*/}
			{/*	type={`text`}*/}
			{/*	placeholder={`내용을 입력해주세요`}*/}
			{/*	name={"body"}*/}
			{/*	value={content.body}*/}
			{/*	onChange={handleCommunityContent}*/}
			{/*	disabled={isLoading}*/}
			{/*/>*/}

			<div className={`edit-community-image-div`}>
				<div className={`edit-community-image-group`}>
					<button
						className={`edit-profile-button`}
						style={{ padding: 0 }}
						onClick={onUploadImageClick}
						disabled={isLoading}
					>
						<input
							type="file"
							multiple="multiple"
							accept="image/*"
							style={{
								display: "none",
							}}
							ref={inputRef}
							onChange={onUploadImage}
						/>
						<img
							src={`/assets/images/channel/img-add.png`}
							// src={`/assets/images/channel/doctor.png`}
							onError={({ currentTarget }) => {
								currentTarget.onerror = null; // prevents looping
								// currentTarget.style.display = "none";
								currentTarget.src = `/assets/images/channel/img-add.png`;
							}}
							alt={`상품 이미지`}
						/>
					</button>
					<Image.PreviewGroup>
						<div className={`image-preview-group`}>
							{imageList?.map((src, idx) => (
								<div
									className={`image-div`}
									key={`image-community-images-key-${idx}`}
								>
									<Image
										preview={{
											mask: <></>,
										}}
										src={src}
										alt={`소통글 이미지 ${idx}`}
									/>
									<img
										src={`/assets/images/channel/cancel.png`}
										alt={`이미지 삭제`}
										className={`image-delete-icon`}
										onClick={() => onDeleteImage(idx)}
										// onClick={() => handleLinkCount("delete", idx)}
									/>
								</div>
							))}
						</div>
					</Image.PreviewGroup>
				</div>
				<p>* 이미지는 최대 5장까지 가능합니다.</p>
			</div>

			{/* 게시/예약 */}
			<Form
				layout={`vertical`}
				style={{
					width: "100%",
				}}
			>
				<Form.Item
					label={<b>공개 상태</b>}
					colon={false}
					style={{
						width: "100%",
						margin: 0,
					}}
				>
					<Radio.Group
						onChange={(e) => {
							setOpenValue(e.target.value);
						}}
						value={openValue}
					>
						<Space>
							<Radio.Button value={1}>공개</Radio.Button>
							<Radio.Button value={2}>예약</Radio.Button>
							{openValue === 2 && (
								<Form
									layout={`vertical`}
									style={{
										width: "100%",
									}}
								>
									<Form.Item
										label={""}
										colon={false}
										style={{
											width: "100%",
											margin: 0,
										}}
									>
										<DatePicker
											className="report-search-date-wrap"
											format="YYYY/MM/DD"
											value={openValueDate ?? null}
											onChange={handleDateTimeValue}
											allowClear={false}
											style={{
												marginRight: "0.5em",
											}}
										/>
										<TimePicker
											format="a h:mm"
											onChange={handleDateTimeValue}
											allowClear={false}
											// defaultValue={openValueDate}
											value={openValueDate ?? null}
										/>
									</Form.Item>
								</Form>
							)}
						</Space>
					</Radio.Group>
				</Form.Item>
			</Form>

			<div className={`edit-community-write-footer`}>
				<Button onClick={goBackToCommunityList} loading={isLoading}>
					목록으로
				</Button>
				<Button
					className={`black`}
					onClick={submitCommunityContent}
					loading={isLoading}
				>
					{selectCommunity?.id ? "수정완료" : "작성완료"}
				</Button>
			</div>
		</div>
	);
};
export default EditCommunityWriteComponent;
